import React from 'react';
import styles from './LoadingSpinner.module.css';
import AnimatedLogo from './AnimatedLogo';

const LoadingSpinner = ({ text = "Generating", fadeOut = false }) => {
  return (
    <div className={`${styles.loadingContainer} ${fadeOut ? styles.fadeOut : ''}`}>
      <div className={styles.logoWrap}>
        <AnimatedLogo animated variant="builder" width={260} />
      </div>
      {text && (
        <p className={styles.loadingText}>{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;